import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { map, Observable } from 'rxjs';
import { AuthServiceService } from './auth-service.service';

@Injectable({
  providedIn: 'root'
})
export class LoginGuard implements CanActivate {
  constructor(private authService: AuthServiceService, private router: Router) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
       // Use the isAuthenticated observable from AuthServiceService to check authentication status
         return this.authService.isAuthenticated.pipe(

           map(isAuthenticated => {
            
             if (isAuthenticated) {
               // If the user is authenticated, allow route activation
               this.router.navigate(['/admin/dashboard']);
               return false;
             } else {
               return true;
             }
           })
         );
  }
  
}
